import zod from "zod";

export const modalUploadProofFormSchema = zod.object({
  attachments: zod
    .array(
      zod.object({
        fileSignedId: zod.string(),
        comment: zod.optional(zod.string()),
      })
    )
    .nonempty(),
});

export type InferredModalUploadProofFormSchema = zod.infer<
  typeof modalUploadProofFormSchema
>;
